import type { WheelOption } from '../types';

/**
 * 휠 옵션.
 *
 * 차량이 실제 GLB 모델로 바뀌면서 스포크 형상이 에셋에 baked되었기 때문에
 * 스포크 수나 림 지름을 런타임에 바꿀 수 없습니다.
 * 그래서 옵션은 림 색상과 마감(metalness/roughness) 변형으로 구성합니다.
 *
 * 형상까지 다른 휠을 제공하려면 휠별 GLB를 따로 준비해서
 * carModels.ts의 역할 매핑에 휠 교체 로직을 추가해야 합니다.
 *
 * 휠 옵션은 모든 차량이 공유합니다. 차종별 순정 휠을 따로 제공하려면
 * carModels.ts의 각 항목에 사용 가능한 휠 id 목록을 두고 걸러야 합니다.
 */
export const wheelOptions: WheelOption[] = [
  {
    id: 'silver-cast',
    name: '실버 캐스트',
    finishLabel: '실버 메탈릭',
    rimColor: '#c9ccd1',
    rimMetalness: 0.9,
    rimRoughness: 0.3,
    price: 0,
  },
  {
    id: 'graphite-satin',
    name: '그라파이트 새틴',
    finishLabel: '무광 그라파이트',
    rimColor: '#6c7078',
    rimMetalness: 0.75,
    rimRoughness: 0.55,
    price: 900000,
  },
  {
    id: 'gloss-black',
    name: '글로스 블랙',
    finishLabel: '유광 블랙',
    rimColor: '#15171b',
    rimMetalness: 0.85,
    rimRoughness: 0.18,
    price: 1500000,
  },
  {
    id: 'bronze-forged',
    name: '브론즈 포지드',
    finishLabel: '브러시드 브론즈',
    rimColor: '#b08d57',
    rimMetalness: 0.92,
    rimRoughness: 0.35,
    price: 1800000,
  },
];
